@if (address(); as address) {
  <div class="delivery-address">
    <sd-radio [formControl]="addressControl" [value]="address.id ?? ''" [name]="'delivery-address'">
      <div class="delivery-address-content color-black">
        <div class="delivery-address-block text-b3-s-500">
          {{ address.formattedAddress }} , {{ address.appartment }}
        </div>
        <div class="delivery-address-details text-b3-s-300">
          @if (address.entrance) {
            <span>подъезд {{ address.entrance }}</span>
          }
          @if (address.floor) {
            <span>этаж {{ address.floor }}</span>
          }
          @if (address.domofon) {
            <span>домофон {{ address.domofon }}</span>
          }
        </div>
      </div>
    </sd-radio>

    <sd-dropdown #dropdown class="delivery-address-dropdown">
      <ng-template #dropdownToggler>
        <sd-dropdown-toggler (click)="onOpenOptions(dropdown)" [hideArrow]="true">
          <button class="btn-icon btn-more">
            <sd-icon class="icon-size-s" [type]="iconTypes.ELLIPSIS" />
          </button>
        </sd-dropdown-toggler>
      </ng-template>

      <ng-template #dropdownContent>
        <sd-dropdown-menu>
          <sd-dropdown-menu-item (click)="dropdown.close(); editAddress($event)">редактировать</sd-dropdown-menu-item>
          <sd-dropdown-menu-item (click)="dropdown.close(); deleteSavedAddress()">удалить</sd-dropdown-menu-item>
        </sd-dropdown-menu>
      </ng-template>
    </sd-dropdown>
  </div>
}
